import { render, staticRenderFns } from "./cell-action-translation-job-resolve.vue?vue&type=template&id=4f75c8d4&scoped=true"
import script from "./cell-action-translation-job-resolve.ts?vue&type=script&lang=ts&external"
export * from "./cell-action-translation-job-resolve.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-action-translation-job-resolve.vue?vue&type=style&index=0&id=4f75c8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f75c8d4",
  null
  
)

export default component.exports